import { render, staticRenderFns } from "./PointsList.vue?vue&type=template&id=ce53e91c&scoped=true&"
import script from "./PointsList.vue?vue&type=script&lang=js&"
export * from "./PointsList.vue?vue&type=script&lang=js&"
import style0 from "./PointsList.vue?vue&type=style&index=0&id=ce53e91c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce53e91c",
  null
  
)

export default component.exports